import type { TrustCard, TrustContent } from '@/content/home';

export type TrustDataHandlingProps = {
  content: TrustContent;
};

export function TrustDataHandling({ content }: TrustDataHandlingProps) {
  return (
    <section
      aria-labelledby="trust-heading"
      className="border-y border-rule bg-page px-6 py-[110px] md:px-[72px]"
    >
      <div className="mx-auto flex max-w-[1296px] flex-col items-center gap-14">
        <div className="flex w-full max-w-[800px] flex-col items-center gap-5 text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-pencil">
            {content.eyebrow}
          </p>
          <h2
            id="trust-heading"
            className="text-[32px] font-bold leading-[1.15] tracking-[-1px] text-ink md:text-[42px]"
          >
            {content.heading}
          </h2>
          <p className="text-[16px] leading-[1.55] text-graphite md:text-[17px]">
            {content.subhead}
          </p>
        </div>

        <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2">
          {content.cards.map((card, idx) => (
            <TrustCardItem key={idx} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TrustCardItem({ card }: { card: TrustCard }) {
  return (
    <article className="flex flex-col gap-4 rounded-[14px] border border-rule bg-canvas p-8">
      <h3 className="text-[20px] font-bold leading-[1.25] tracking-[-0.3px] text-ink md:text-[21px]">
        {card.title}
      </h3>
      <p className="text-[15px] leading-[1.6] text-graphite">{card.body}</p>
      {card.screenshot && (
        <img
          src={card.screenshot}
          alt=""
          aria-hidden="true"
          className="h-[180px] w-full rounded-[10px] border border-rule object-cover md:h-[220px]"
        />
      )}
    </article>
  );
}
